// Tab navigation - matching GroupContainer structure
export const ALL_GROUPS_TABS: Record<
  string,
  {
    id: string
    route: string
    isAdminOnly?: boolean
    url?: string
  }
> = {
  home: {
    id: 'home',
    route: 'communities-groups-home',
    url: '/home',
  },
  learning: {
    id: 'learning',
    route: 'communities-groups-learning',
    url: '/learning',
  },
  events: {
    id: 'events',
    route: 'communities-groups-events',
    url: '/events',
  },
  leaderboard: {
    id: 'leaderboard',
    route: 'communities-groups-leaderboard',
    url: '/leaderboard',
  },
  members: {
    id: 'members',
    route: 'communities-groups-members',
    url: '/members',
  },
  about: {
    id: 'about',
    route: 'communities-groups-about',
    url: '/about',
  },
  settings: {
    id: 'settings',
    route: 'communities-groups-settings-details',
    isAdminOnly: true,
    url: '/settings',
  },
} as const

// Tabs that are always visible regardless of configuration
export const MANDATORY_GROUP_TAB_IDS = ['home', 'about'] as const

// Tabs that can be toggled on/off by admins
export const OPTIONAL_GROUP_TAB_IDS = ['learning', 'events', 'leaderboard', 'members'] as const

// Content tabs persisted in group settings. Admin-only navigation tabs like "settings" are intentionally excluded.
export const CONTENT_GROUP_TABS = [
  { id: 'home', name: 'DISCUSSION' },
  { id: 'learning', name: 'LEARNING' },
  { id: 'events', name: 'EVENTS' },
  { id: 'leaderboard', name: 'LEADERBOARD' },
  { id: 'members', name: 'MEMBERS' },
  { id: 'about', name: 'ABOUT' },
] as const

export type GroupTabName = (typeof CONTENT_GROUP_TABS)[number]['name']

/** Backend tab order for tabsConfiguration array (matches API) */
export const GROUP_TAB_NAMES: GroupTabName[] = CONTENT_GROUP_TABS.map(({ name }) => name)
